import { Dispatch }                       from 'react';
import { DrawerBackdrop }                 from "@/components/ui/drawer";
import { DrawerBody }                     from "@/components/ui/drawer";
import { DrawerCloseTrigger }             from "@/components/ui/drawer";
import { DrawerContent }                  from "@/components/ui/drawer";
import { DrawerFooter }                   from "@/components/ui/drawer";
import { DrawerHeader }                   from "@/components/ui/drawer";
import { DrawerRoot, }                    from "@/components/ui/drawer";
import { DrawerTitle, }                   from "@/components/ui/drawer";
import NavigationFooter                   from '@/components/navigation/NavigationFooter';
import NavigationMenu                     from '@/components/navigation/NavigationMenu';
import NavigationSearch                   from '@/components/navigation/NavigationSearch';
import React                              from 'react';
import { SetStateAction }                 from 'react';
import useSearch                          from '@/hooks/useSearch';

interface INavBarProps {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
}

const Drawer = (props: React.PropsWithChildren<INavBarProps>) => {
    const { children, isOpen, setIsOpen } = props;    
    const { searchInputValue, setSearchInputValue, searchResults } = useSearch();

    return (
        <DrawerRoot 
            open={isOpen}
            placement="start" 
            size="full"
        >
            <DrawerBackdrop />
            <DrawerContent>
                <DrawerHeader>
                    <DrawerTitle paddingRight={7}>
                        <NavigationSearch 
                            searchInputValue={searchInputValue} 
                            setSearchInputValue={setSearchInputValue} 
                        />
                    </DrawerTitle>
                </DrawerHeader>
                <DrawerBody>
                    <NavigationMenu setOpen={setIsOpen} searchResults={searchResults} />
                </DrawerBody>
                <DrawerFooter width="100%" placeContent="start">
                    <NavigationFooter />
                </DrawerFooter>
                <DrawerCloseTrigger onClick={() => setIsOpen(false)} />
            </DrawerContent>
            {children}
        </DrawerRoot>
    )
}

export default Drawer;